import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import { AccordionTab } from 'primereact/accordion';
import { IntlShape } from 'react-intl';
import { Divider } from 'primereact/divider';

export const renderDetailAccordionTab = (intl: IntlShape, rows: ReactNode[], header: string): ReactElement => {
  if (!rows.length) return null;
  return <AccordionTab key={header} header={intl.formatMessage({id: header})}>
    {rows.map((row, index, array) => <div key={index} className={'flex flex-column'}>
      {row}
      {index + 1 < array.length && <Divider/>}
    </div>)}
  </AccordionTab>;
};
